import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default (WrappedComponent) => {
	const withIsActive = class extends Component {
		constructor(props) {
			super(props);

			this.onFocus = this.onFocus.bind(this);
			this.onBlur = this.onBlur.bind(this);

			this.state = { isActive: false };
		}

		onBlur(event) {
			this.setState({ isActive: false });
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
		}

		onFocus(event) {
			this.setState({ isActive: true });
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
		}
		render() {
			return (
				<WrappedComponent
					{...{
						...this.props,
						onFocus: this.onFocus,
						onBlur: this.onBlur,
						isActive: this.state.isActive,
					}}
				/>
			);
		}
	};

	withIsActive.displayName = `withIsActive(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

	withIsActive.propTypes = {
		onBlur: PropTypes.func,
		onFocus: PropTypes.func,
	};

	return withIsActive;
};
